import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Open Razorpay checkout modal.
 * options: { packageId?: 'basic'|'premium', amount?: number, purpose?: string, referenceId?: string, onSuccess?, onFailure? }
 */
export async function openRazorpayCheckout(options) {
  if (typeof window === 'undefined' || !window.Razorpay) {
    toast.error('Payment gateway is loading. Please refresh and try again.');
    return;
  }

  try {
    // Step 1: Create order on backend
    const { data: orderData } = await axios.post(
      `${API}/razorpay/create-order`,
      {
        package_id: options.packageId,
        amount: options.amount,
        purpose: options.purpose || 'consultation',
        reference_id: options.referenceId || null,
      },
      { withCredentials: true }
    );

    // Step 2: Configure Razorpay
    const rzpOptions = {
      key: orderData.key_id,
      amount: orderData.amount,
      currency: orderData.currency,
      name: 'SecondDoctorOpinion.com',
      description: options.purpose === 'video_consult' ? 'Video Consultation' : 'Medical Second Opinion',
      order_id: orderData.order_id,
      prefill: {
        name: orderData.user_name || '',
        email: orderData.user_email || '',
        contact: orderData.user_phone || '',
      },
      theme: { color: '#4A6750' },
      handler: async (response) => {
        try {
          await axios.post(
            `${API}/razorpay/verify-payment`,
            {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              transaction_id: orderData.transaction_id,
            },
            { withCredentials: true }
          );
          toast.success('Payment successful!');
          if (options.onSuccess) options.onSuccess(response);
        } catch (e) {
          toast.error('Payment verification failed. Contact support.');
          if (options.onFailure) options.onFailure(e);
        }
      },
      modal: {
        ondismiss: () => {
          toast.info('Payment cancelled');
          if (options.onFailure) options.onFailure(null);
        },
      },
    };

    const rzp = new window.Razorpay(rzpOptions);
    rzp.on('payment.failed', (resp) => {
      toast.error(`Payment failed: ${resp.error?.description || 'Unknown error'}`);
      if (options.onFailure) options.onFailure(resp);
    });
    rzp.open();
  } catch (error) {
    const detail = error.response?.data?.detail || error.message;
    toast.error(typeof detail === 'string' ? detail : 'Failed to start payment');
    if (options.onFailure) options.onFailure(error);
  }
}
